// ======================================================
// INCLYNE PRICING CALCULATOR
// VERSION 2
// ======================================================

const CONFIG = {

    // ==================================================
    // CREDIT VALUES
    // ==================================================

    api:{
    url:"https://inclyne-calculator-api.mrabdullahokaroh.workers.dev"
},

creditValues:{
    oneOff:75
},
payment:{
    depositPercentage:30,
    depositThreshold:200,
    shopifyVariantId:"58782183326028"
},

    // ==================================================
    // GLOBAL QUESTIONS
    // ==================================================

    globalQuestions:{
  
        businessSize:{

            id:"businessSize",

            type:"single",

            question:"How large is your business?",

            description:"This helps us estimate the level of support required.",

            options:{

                justMe:{
                    label:"Just me",
                    multiplier:1
                },

                twoToTen:{
                    label:"2–10 employees",
                    multiplier:1.1
                },

                elevenToFifty:{
                    label:"11–50 employees",
                    multiplier:1.25
                },

                fiftyOnePlus:{
                    label:"51+ employees",
                    multiplier:1.5
                }

            }

        },

        countries:{

            id:"countries",

            type:"single",

            question:"How many countries do you market to?",

            description:"Managing multiple markets increases complexity.",

            options:{

                one:{
                    label:"One country",
                    multiplier:1
                },

                twoToFive:{
                    label:"2–5 countries",
                    multiplier:1.25
                },

                sixToTen:{
                    label:"6–10 countries",
                    multiplier:1.5
                },

                tenPlus:{
                    label:"10+ countries",
                    multiplier:2
                }

            }

        },

        marketingBudget:{

            id:"marketingBudget",

            type:"single",

            question:"What is your monthly marketing budget?",

            description:"We'll use this as one of several weighting factors.",

            options:{

                under500:{
                    label:"Under £500",
                    multiplier:1
                },

                fiveHundredToTwoThousand:{
                    label:"£500–£2,000",
                    multiplier:1
                },

                twoToFiveThousand:{
                    label:"£2,000–£5,000",
                    multiplier:1.1
                },

                fiveThousandPlus:{
                    label:"£5,000+",
                    multiplier:1.25
                }

            }

        }

    },

// ==================================================
// SERVICES
// ==================================================

services:{
// ==================================================
// SEO
// ==================================================
SEO:{

    id:"seo",

    displayName:"SEO",

    tasks:{

        technicalSeoAudit:{

            name:"Technical SEO Audit",

            credits:2,

            specialistPercentage:0.70,

            support:["oneOff"],

            questions:[

                {

                    id:"technicalSeoPages",

                    type:"single",

                    question:"How many pages should the technical SEO audit cover?",

                    description:"This helps us estimate the scope of the technical audit.",

                    options:{

                        oneToFive:{

                            label:"1–5 pages",

                            multiplier:1

                        },

                        sixToTen:{

                            label:"6–10 pages",

                            multiplier:1.5

                        },

                        elevenToFifteen:{

                            label:"11–15 pages",

                            multiplier:2

                        },

                        sixteenToTwenty:{

                            label:"16–20 pages",

                            multiplier:2.5

                        }

                    }

                }

            ]

        },

        onPageOptimisation:{

            name:"On-page Optimisation",

            credits:2,

            specialistPercentage:0.65,

            support:["oneOff"],

            questions:[

                {

                    id:"onPagePages",

                    type:"single",

                    question:"How many pages would you like us to optimise?",

                    description:"This helps us estimate the scope of the optimisation work.",

                    options:{

                        oneToFive:{

                            label:"1–5 pages",

                            multiplier:1

                        },

                        sixToTen:{

                            label:"6–10 pages",

                            multiplier:1.5

                        },

                        elevenToFifteen:{

                            label:"11–15 pages",

                            multiplier:2

                        },

                        sixteenToTwenty:{

                            label:"16–20 pages",

                            multiplier:2.5

                        }

                    }

                }

            ]

        },

        keywordResearch:{

    name:"Keyword Research",

    credits:2,

    specialistPercentage:0.65,

    support:["oneOff"],

    questions:[

        {

            id:"seoKeywordFocus",

            type:"single",

            question:"What would you like the keyword research to focus on?",

            description:"Select the main area you would like us to research.",

            options:{

                products:{

                    label:"Products",

                    multiplier:1

                },

                services:{

                    label:"Services",

                    multiplier:1

                },

                categories:{

                    label:"Categories",

                    multiplier:1

                },

                topics:{

                    label:"Topics / Content",

                    multiplier:1

                },

                locations:{

                    label:"Locations",

                    multiplier:1

                },

                combination:{

                    label:"A combination of these",

                    multiplier:1.25

                }

            }

        },

        {

            id:"seoKeywordAreas",

            type:"single",

            question:"How many areas should the research cover?",

            description:"This helps us estimate the overall research scope.",

            options:{

                one:{

                    label:"1 area",

                    multiplier:1

                },

                twoToFive:{

                    label:"2–5 areas",

                    multiplier:1.25

                },

                sixToTen:{

                    label:"6–10 areas",

                    multiplier:1.5

                },

                elevenToFifteen:{

                    label:"11–15 areas",

                    multiplier:2

                }

            }

        },

        {

            id:"seoKeywordsPerArea",

            type:"single",

            question:"How many keywords would you like per area?",

            description:"This helps us estimate the depth of keyword research required.",

            options:{

                oneToTen:{

                    label:"1–10 keywords",

                    multiplier:1

                },

                elevenToTwenty:{

                    label:"11–20 keywords",

                    multiplier:1.5

                },

                twentyOneToThirty:{

                    label:"21–30 keywords",

                    multiplier:1.75

                }

            }

        }

    ]

},

        seoCompetitorAnalysis:{

            name:"SEO Competitor Analysis",

            credits:2,

            specialistPercentage:0.65,

            support:["oneOff"],

            questions:[

                {

                    id:"seoCompetitors",

                    type:"single",

                    question:"How many competitors would you like us to analyse?",

                    description:"This helps us estimate the depth of research required.",

                    options:{

                        oneToTwo:{

                            label:"1–2 competitors",

                            multiplier:1

                        },

                        threeToFive:{

                            label:"3–5 competitors",

                            multiplier:1.5

                        },

                        sixToTen:{

                            label:"6–10 competitors",

                            multiplier:2

                        }

                    }

                }

            ]

        },

        seoContentStrategy:{

            name:"SEO Content Strategy",

            credits:3,

            specialistPercentage:0.70,

            support:["oneOff"],

            questions:[

                {

                    id:"contentStrategy",

                    type:"single",

                    question:"How many months should the content strategy cover?",

                    description:"Select the planning period required.",

                    options:{

                        oneMonth:{

                            label:"1 month",

                            multiplier:1

                        },

                        threeMonths:{

                            label:"3 months",

                            multiplier:1.5

                        },

                        sixMonths:{

                            label:"6 months",

                            multiplier:2

                        }

                    }

                }

            ]

        },

        seoPlatformIntegration:{

            name:"SEO Platform Integration",

            credits:2,

            specialistPercentage:0.60,

            support:["oneOff"],

            questions:[

                {

                    id:"seoPlatforms",

                    type:"multi",

                    question:"Which SEO platforms would you like us to integrate?",

                    description:"Select all that apply.",

                    options:{

                        searchConsole:{

                            label:"Google Search Console",

                            multiplier:1

                        },

                        analytics:{

                            label:"Google Analytics",

                            multiplier:1

                        },

                        semrush:{

                            label:"SEMrush",

                            multiplier:1.25

                        },

                        ahrefs:{

                            label:"Ahrefs",

                            multiplier:1.25

                        },

                        moz:{

                            label:"Moz",

                            multiplier:1.1

                        }

                    }

                }

            ]

        },

        landingPageCopy:{

            name:"Landing Page Copy",

            credits:3,

            specialistPercentage:0.70,

            support:["oneOff"],

            questions:[

                {

                    id:"seoLandingPages",

                    type:"single",

                    question:"How many landing pages would you like us to produce?",

                    description:"This helps us estimate the scope of the copywriting work.",

                    options:{

                        oneToFive:{

                            label:"1–5 landing pages",

                            multiplier:1

                        },

                        sixToTen:{

                            label:"6–10 landing pages",

                            multiplier:1.5

                        },

                        elevenToFifteen:{

                            label:"11–15 landing pages",

                            multiplier:2

                        },

                        sixteenToTwenty:{

                            label:"16–20 landing pages",

                            multiplier:2.5

                        }

                    }

                }

            ]

        },

        blogCreation:{

            name:"Blog Creation",

            credits:3,

            specialistPercentage:0.65,

            support:["oneOff"],

            questions:[

                {

                    id:"seoBlogs",

                    type:"single",

                    question:"How many blog articles would you like us to produce?",

                    description:"This helps us estimate the amount of content required.",

                    options:{

                        oneToFive:{

                            label:"1–5 blogs",

                            multiplier:1

                        },

                        sixToTen:{

                            label:"6–10 blogs",

                            multiplier:1.5

                        },

                        elevenToFifteen:{

                            label:"11–15 blogs",

                            multiplier:2

                        },

                        sixteenToTwenty:{

                            label:"16–20 blogs",

                            multiplier:2.5

                        }

                    }

                }

            ]

        },

        internalLinkingOptimisation:{

            name:"Internal Linking Optimisation",

            credits:2,

            specialistPercentage:0.60,

            support:["oneOff"],

            questions:[

                {

                    id:"internalLinkingPages",

                    type:"single",

                    question:"How many pages would you like us to optimise?",

                    description:"This helps us estimate the amount of internal linking work required.",

                    options:{

                        oneToFive:{

                            label:"1–5 pages",

                            multiplier:1

                        },

                        sixToTen:{

                            label:"6–10 pages",

                            multiplier:1.5

                        },

                        elevenToFifteen:{

                            label:"11–15 pages",

                            multiplier:2

                        },

                        sixteenToTwenty:{

                            label:"16–20 pages",

                            multiplier:2.5

                        }

                    }

                }

            ]

        },

        seoReportingSetup:{

            name:"SEO Reporting Setup",

            credits:2,

            specialistPercentage:0.60,

            support:["oneOff"],

            questions:[

                {

                    id:"seoReportingPlatforms",

                    type:"multi",

                    question:"Which reporting platforms would you like us to set up?",

                    description:"Select all that apply.",

                    options:{

                        googleAnalytics:{

                            label:"Google Analytics",

                            multiplier:1

                        },

                        searchConsole:{

                            label:"Google Search Console",

                            multiplier:1

                        },

                        lookerStudio:{

                            label:"Looker Studio",

                            multiplier:1.25

                        },

                        semrush:{

                            label:"SEMrush",

                            multiplier:1.25

                        }

                    }

                }

            ]

        },

        seoMigrationSupport:{

            name:"SEO Migration Support",

            credits:4,

            specialistPercentage:0.70,

            support:["oneOff"],

            questions:[

                {

                    id:"seoMigrationPages",

                    type:"single",

                    question:"How many pages are involved in the migration?",

                    description:"This helps us estimate the migration workload.",

                    options:{

                        oneToFive:{

                            label:"1–5 pages",

                            multiplier:1

                        },

                        sixToTen:{

                            label:"6–10 pages",

                            multiplier:1.5

                        },

                        elevenToFifteen:{

                            label:"11–15 pages",

                            multiplier:2

                        },

                        sixteenToTwenty:{

                            label:"16–20 pages",

                            multiplier:2.5

                        }

                    }

                }

            ]

        },

        googleBusinessProfileSetup:{

            name:"Google Business Profile Setup",

            credits:2,

            specialistPercentage:0.60,

            support:["oneOff"],

            questions:[

                {

                    id:"googleBusinessProfiles",

                    type:"single",

                    question:"How many Google Business Profiles do you need us to set up?",

                    description:"This helps us estimate the setup required.",

                    options:{

                        one:{

                            label:"1 profile",

                            multiplier:1

                        },

                        twoToThree:{

                            label:"2–3 profiles",

                            multiplier:1.5

                        },

                        fourToFive:{

                            label:"4–5 profiles",

                            multiplier:2

                        }

                    }

                }

            ]

        },

        localCitationBuilding:{

            name:"Local Citation Building",

            credits:3,

            specialistPercentage:0.60,

            support:["oneOff"],

            questions:[

                {

                    id:"localCitations",

                    type:"single",

                    question:"How many local citations would you like us to build?",

                    description:"This helps us estimate the amount of citation-building work required.",

                    options:{

                        oneToTen:{

                            label:"1–10 citations",

                            multiplier:1

                        },

                        elevenToTwenty:{

                            label:"11–20 citations",

                            multiplier:1.5

                        },

                        twentyOneToThirty:{

                            label:"21–30 citations",

                            multiplier:2

                        }

                    }

                }

            ]

        }

    }

},
 // ==================================================
// PPC
// ==================================================

PPC:{

    id:"ppc",

    displayName:"PPC",

    tasks:{

     newCampaignSetup:{

    name:"New Campaign Setup",

    credits:3,

    specialistPercentage:0.65,

    support:["oneOff"],

    questions:[

        {

            id:"ppcPlatforms",

            type:"multi",

            question:"Which platforms would you like the PPC work completed on?",

            description:"Select all platforms that apply.",

            options:{

                google:{

                    label:"Google",

                    multiplier:1.25

                },

                meta:{

                    label:"Meta",

                    multiplier:1

                },

                microsoft:{

                    label:"Microsoft",

                    multiplier:1.25

                },

                tiktok:{

                    label:"TikTok",

                    multiplier:1.5

                },

                amazon:{

                    label:"Amazon",

                    multiplier:1.75

                }

            }

        },

        {

            id:"newCampaigns",

            type:"single",

            question:"How many campaigns need to be set up?",

            description:"Select the number of campaigns you need set up.",

            options:{

                one:{

                    label:"1 campaign",

                    multiplier:1

                },

                twoToFive:{

                    label:"2–5 campaigns",

                    multiplier:1.25

                },

                sixToTen:{

                    label:"6–10 campaigns",

                    multiplier:1.5

                },

                elevenToFifteen:{

                    label:"11–15 campaigns",

                    multiplier:2

                },

                sixteenToTwenty:{

                    label:"16–20 campaigns",

                    multiplier:2.5

                }

            }

        }

    ]

},

        ppcAudit:{

    name:"PPC Audit",

    credits:2,

    specialistPercentage:0.70,

    support:["oneOff"],

    questions:[

        {

            id:"ppcAuditPlatforms",

            type:"multi",

            question:"Which platforms would you like the PPC audit completed on?",

            description:"Select all platforms that apply.",

            options:{

                google:{

                    label:"Google",

                    multiplier:1.25

                },

                meta:{

                    label:"Meta",

                    multiplier:1

                },

                microsoft:{

                    label:"Microsoft",

                    multiplier:1.25

                },

                tiktok:{

                    label:"TikTok",

                    multiplier:1.5

                },

                amazon:{

                    label:"Amazon",

                    multiplier:1.75

                }

            }

        },

        {

            id:"ppcAuditCampaigns",

            type:"single",

            question:"How many campaigns need to be audited?",

            description:"Select the number of campaigns you need audited.",

            options:{

                one:{

                    label:"1 campaign",

                    multiplier:1

                },

                twoToFive:{

                    label:"2–5 campaigns",

                    multiplier:1.25

                },

                sixToTen:{

                    label:"6–10 campaigns",

                    multiplier:1.5

                },

                elevenToFifteen:{

                    label:"11–15 campaigns",

                    multiplier:2

                },

                sixteenToTwenty:{

                    label:"16–20 campaigns",

                    multiplier:2.5

                }

            }

        }

    ]

},
       conversionTracking:{

    name:"Conversion Tracking",

    credits:3,

    specialistPercentage:0.70,

    support:["oneOff"],

    questions:[

        {

            id:"conversionTrackingPlatforms",

            type:"multi",

            question:"Which platforms would you like conversion tracking set up for?",

            description:"Select all platforms that apply.",

            options:{

                google:{

                    label:"Google",

                    multiplier:1.25

                },

                meta:{

                    label:"Meta",

                    multiplier:1

                },

                microsoft:{

                    label:"Microsoft",

                    multiplier:1.25

                },

                tiktok:{

                    label:"TikTok",

                    multiplier:1.5

                },

                amazon:{

                    label:"Amazon",

                    multiplier:1.75

                }

            }

        },

        {

            id:"trackingTools",

            type:"multi",

           question:"Which tracking tools need to be set up?",

            description:"Select all tracking tools that apply.",

            options:{

                googleAds:{

                    label:"Google Ads",

                    multiplier:1

                },

                gtm:{

                    label:"Google Tag Manager",

                    multiplier:1.25

                },

                metaPixel:{

                    label:"Meta Pixel",

                    multiplier:1.15

                },

                tiktokPixel:{

                    label:"TikTok Pixel",

                    multiplier:1.15

                }

            }

        }

    ]

},

        keywordResearchStrategy:{

    name:"Keyword Research & Strategy",

    credits:2,

    specialistPercentage:0.65,

    support:["oneOff"],

  questions:[

    {

        id:"ppcKeywordPlatforms",

        type:"multi",

        question:"Which platforms would you like the keyword research completed for?",

        description:"Select all platforms that apply.",

        options:{

            google:{

                label:"Google",

                multiplier:1

            },

            
            microsoft:{

                label:"Microsoft",

                multiplier:1

            },

            tiktok:{

                label:"TikTok",

                multiplier:1.25

            },

            amazon:{

                label:"Amazon",

                multiplier:1.50

            }

        }

    },

    {

        id:"ppcKeywordCampaigns",

            type:"single",

            question:"How many campaigns should the keyword research cover?",

            description:"This helps us estimate the overall research scope.",

            options:{

                one:{

                    label:"1 campaign",

                    multiplier:1

                },

                twoToFive:{

                    label:"2–5 campaigns",

                    multiplier:1.25

                },

                sixToTen:{

                    label:"6–10 campaigns",

                    multiplier:1.5

                },

                elevenToFifteen:{

                    label:"11–15 campaigns",

                    multiplier:2

                },

                sixteenToTwenty:{

                    label:"16–20 campaigns",

                    multiplier:2.5

                }

            }

        },

        {

            id:"keywordsPerCampaign",

            type:"single",

            question:"How many keywords would you like per campaign?",

            description:"This helps us estimate the depth of keyword research required.",

            options:{

                oneToTen:{

                    label:"1–10 keywords",

                    multiplier:1

                },

                elevenToTwenty:{

                    label:"11–20 keywords",

                    multiplier:1.5

                },

                twentyOneToThirty:{

                    label:"21–30 keywords",

                    multiplier:2

                }

            }

        }

    ]

},
        adCopyCreation:{

    name:"Ad Copy Creation",

    credits:2,

    specialistPercentage:0.65,

    support:["oneOff"],

    questions:[

    {

        id:"adCopyPlatforms",

        type:"multi",

        question:"Which platforms would you like the ad copy created for?",

        description:"Select all platforms that apply.",

        options:{

            google:{

                label:"Google",

                multiplier:1.25

            },

            meta:{

                label:"Meta",

                multiplier:1

            },

            microsoft:{

                label:"Microsoft",

                multiplier:1.25

            },

            tiktok:{

                label:"TikTok",

                multiplier:1.5

            },

            amazon:{

                label:"Amazon",

                multiplier:1.75

            }

        }

    },

    {

        id:"adCopyCampaigns",

            type:"single",

            question:"How many campaigns would you like ad copy for?",

            description:"This helps us estimate the overall ad copy workload.",

            options:{

                one:{

                    label:"1 campaign",

                    multiplier:1

                },

                twoToFive:{

                    label:"2–5 campaigns",

                    multiplier:1.25

                },

                sixToTen:{

                    label:"6–10 campaigns",

                    multiplier:1.5

                },

                elevenToFifteen:{

                    label:"11–15 campaigns",

                    multiplier:2

                },

                sixteenToTwenty:{

                    label:"16–20 campaigns",

                    multiplier:2.5

                }

            }

        },

        {

            id:"adsPerCampaign",

            type:"single",

            question:"How many ads would you like per campaign?",

            description:"This helps us estimate the amount of ad copy required for each campaign.",

            options:{

                oneToFive:{

                    label:"1–5 ads",

                    multiplier:1

                },

                sixToTen:{

                    label:"6–10 ads",

                    multiplier:1.5

                },

                elevenToFifteen:{

                    label:"11–15 ads",

                    multiplier:2

                },

                sixteenToTwenty:{

                    label:"16–20 ads",

                    multiplier:2.5

                }

            }

        }

    ]

},
        landingPageAudit:{

    name:"Landing Page Audit",

    credits:2,

    specialistPercentage:0.65,

    support:["oneOff"],

    questions:[

        {

            id:"landingPageAuditPages",

            type:"single",

            question:"How many pages should the audit cover?",

            description:"This helps us estimate the scope of the audit.",

            options:{

                oneToFive:{

                    label:"1–5 pages",

                    multiplier:1

                },

                sixToTen:{

                    label:"6–10 pages",

                    multiplier:1.5

                },

                elevenToFifteen:{

                    label:"11–15 pages",

                    multiplier:2

                },

                sixteenToTwenty:{

                    label:"16–20 pages",

                    multiplier:2.5

                }

            }

        }

    ]

},
      audienceTargetingSetup:{

    name:"Audience & Targeting Setup",

    credits:2,

    specialistPercentage:0.65,

    support:["oneOff"],

   questions:[

    {

        id:"audiencePlatforms",

        type:"multi",

        question:"Which platforms would you like the targeting setup for?",

        description:"Select all platforms that apply.",

        options:{

            google:{

                label:"Google",

                multiplier:1.25

            },

            meta:{

                label:"Meta",

                multiplier:1

            },

            microsoft:{

                label:"Microsoft",

                multiplier:1.25

            },

            tiktok:{

                label:"TikTok",

                multiplier:1.5

            },

            amazon:{

                label:"Amazon",

                multiplier:1.75

            }

        }

    },

 {
    id:"campaigns",
    type:"single",
    question:"How many campaigns require targeting setup?",
    options:{
        one:{
            label:"1 campaign",
            multiplier:1
        },
        twoToFive:{
            label:"2–5 campaigns",
            multiplier:1.25
        },
        sixToTen:{
            label:"6–10 campaigns",
            multiplier:1.5
        },
        elevenToFifteen:{
            label:"11–15 campaigns",
            multiplier:2
        },
        sixteenToTwenty:{
            label:"16–20 campaigns",
            multiplier:2.5
        }
    }
},
{
    id:"targetingGroups",
    type:"single",
    question:"How many targeting groups require setup per campaign?",
    description:"For example, ad groups on Google/Microsoft/TikTok or ad sets on Meta.",
    options:{
        one:{
            label:"1 targeting group",
            multiplier:1
        },
        twoToThree:{
            label:"2–3 targeting groups",
            multiplier:1.5
        },
        fourToFive:{
            label:"4–5 targeting groups",
            multiplier:2
        },
        sixToTen:{
            label:"6–10 targeting groups",
            multiplier:2.5
        }
    }
}
    ]

},
       ppcAccountRestructure:{

    name:"PPC Account Restructure",

    credits:4,

    specialistPercentage:0.70,

    support:["oneOff"],

    questions:[

        {

            id:"restructurePlatforms",

            type:"multi",

            question:"Which platforms would you like the account restructured on?",

            description:"Select all platforms that apply.",

            options:{

                google:{

                    label:"Google",

                    multiplier:1.25

                },

                meta:{

                    label:"Meta",

                    multiplier:1

                },

                microsoft:{

                    label:"Microsoft",

                    multiplier:1.25

                },

                tiktok:{

                    label:"TikTok",

                    multiplier:1.5

                },

                amazon:{

                    label:"Amazon",

                    multiplier:1.75

                }

            }

        },

        {

            id:"restructureCampaigns",

            type:"single",

            question:"How many campaigns need to be restructured?",

            description:"This helps us estimate the scale of the restructuring work.",

            options:{

                oneToFive:{

                    label:"1–5 campaigns",

                    multiplier:1

                },

                sixToTen:{

                    label:"6–10 campaigns",

                    multiplier:1.5

                },

                elevenToFifteen:{

                    label:"11–15 campaigns",

                    multiplier:2

                },

                sixteenToTwenty:{

                    label:"16–20 campaigns",

                    multiplier:2.5

                }

            }

        }

    ]

},
       shoppingCampaignSetup:{

    name:"Shopping Campaign Setup",

    credits:3,

    specialistPercentage:0.65,

    support:["oneOff"],

    questions:[

        {

            id:"shoppingPlatforms",

            type:"multi",

            question:"Which platforms would you like the Shopping campaigns set up on?",

            description:"Select all platforms that apply.",

            options:{

                google:{

                    label:"Google",

                    multiplier:1.25

                },

                meta:{

                    label:"Meta",

                    multiplier:1

                },

                microsoft:{

                    label:"Microsoft",

                    multiplier:1.25

                },

                tiktok:{

                    label:"TikTok",

                    multiplier:1.5

                },

                amazon:{

                    label:"Amazon",

                    multiplier:1.75

                }

            }

        },

        {

            id:"shoppingCampaigns",

            type:"single",

            question:"How many Shopping campaigns would you like set up?",

            description:"This helps us estimate the campaign setup workload.",

            options:{

                one:{

                    label:"1 campaign",

                    multiplier:1

                },

                twoToFive:{

                    label:"2–5 campaigns",

                    multiplier:1.25

                },

                sixToTen:{

                    label:"6–10 campaigns",

                    multiplier:1.5

                },

                elevenToFifteen:{

                    label:"11–15 campaigns",

                    multiplier:2

                },

                sixteenToTwenty:{

                    label:"16–20 campaigns",

                    multiplier:2.5

                }

            }

        },

        {

            id:"shoppingSkus",

            type:"single",

            question:"How many SKUs will be included in the Shopping campaign?",

            description:"This helps us estimate the product setup and feed workload.",

            options:{

                oneToTen:{

                    label:"1–10 SKUs",

                    multiplier:1

                },

                elevenToTwenty:{

                    label:"11–20 SKUs",

                    multiplier:1.25

                },

                twentyOneToThirty:{

                    label:"21–30 SKUs",

                    multiplier:1.5

                },

                thirtyOneToForty:{

                    label:"31–40 SKUs",

                    multiplier:2

                },

                fortyOneToFifty:{

                    label:"41–50 SKUs",

                    multiplier:2.5

                }

            }

            }

    ]

},

}

},

// ==================================================

// WEBSITE CREATION
// ==================================================

"Website Creation":{

    id:"website",

    displayName:"Web",

    tasks:{

        starterWebsite:{

            name:"Starter Website",

            credits:6,

            specialistPercentage:0.70,

            support:["oneOff"],

            questions:[

                {

                    id:"starterWebsitePages",

                    type:"single",

                    question:"How many pages would you like your website to have?",

                    description:"This helps us estimate the website build workload.",

                    options:{

                        oneToFive:{

                            label:"1–5 pages",

                            multiplier:1

                        },

                        sixToTen:{

                            label:"6–10 pages",

                            multiplier:1.5

                        },

                        elevenToFifteen:{

                            label:"11–15 pages",

                            multiplier:2

                        },

                        sixteenToTwenty:{

                            label:"16–20 pages",

                            multiplier:2.5

                        }

                    }

                }

            ]

        },

        landingPageCreation:{

            name:"Landing Page Creation",

            credits:3,

            specialistPercentage:0.65,

            support:["oneOff"],

            questions:[

                {

                    id:"landingPageCreationPages",

                    type:"single",

                    question:"How many landing pages would you like us to create?",

                    description:"This helps us estimate the scope of the page creation work.",

                    options:{

                        oneToFive:{

                            label:"1–5 pages",

                            multiplier:1

                        },

                        sixToTen:{

                            label:"6–10 pages",

                            multiplier:1.5

                        },

                        elevenToFifteen:{

                            label:"11–15 pages",

                            multiplier:2

                        },

                        sixteenToTwenty:{

                            label:"16–20 pages",

                            multiplier:2.5

                        }

                    }

                }

            ]

        },

        uxPerformanceAudit:{

            name:"UX & Performance Audit",

            credits:2,

            specialistPercentage:0.65,

            support:["oneOff"],

            questions:[

                {

                    id:"uxAuditPages",

                    type:"single",

                    question:"How many pages should the audit cover?",

                    description:"This helps us estimate the scope of the UX and performance audit.",

                    options:{

                        oneToFive:{

                            label:"1–5 pages",

                            multiplier:1

                        },

                        sixToTen:{

                            label:"6–10 pages",

                            multiplier:1.5

                        },

                        elevenToFifteen:{

                            label:"11–15 pages",

                            multiplier:2

                        },

                        sixteenToTwenty:{

                            label:"16–20 pages",

                            multiplier:2.5

                        }

                    }

                }

            ]

        },

        websiteRedesign:{

            name:"Website Redesign",

            credits:7,

            specialistPercentage:0.70,

            support:["oneOff"],

            questions:[

                {

                    id:"websiteRedesignPages",

                    type:"single",

                    question:"How many pages would you like redesigned?",

                    description:"This helps us estimate the scope of the redesign.",

                    options:{

                        oneToFive:{

                            label:"1–5 pages",

                            multiplier:1

                        },

                        sixToTen:{

                            label:"6–10 pages",

                            multiplier:1.5

                        },

                        elevenToFifteen:{

                            label:"11–15 pages",

                            multiplier:2

                        },

                        sixteenToTwenty:{

                            label:"16–20 pages",

                            multiplier:2.5

                        }

                    }

                }

            ]

        },

        websiteMigration:{

            name:"Website Migration",

            credits:4,

            specialistPercentage:0.70,

            support:["oneOff"],

            questions:[

                {

                    id:"websiteMigrationPages",

                    type:"single",

                    question:"How many pages are involved in the migration?",

                    description:"This helps us estimate the migration workload.",

                    options:{

                        oneToFive:{

                            label:"1–5 pages",

                            multiplier:1

                        },

                        sixToTen:{

                            label:"6–10 pages",

                            multiplier:1.5

                        },

                        elevenToFifteen:{

                            label:"11–15 pages",

                            multiplier:2

                        },

                        sixteenToTwenty:{

                            label:"16–20 pages",

                            multiplier:2.5

                        }

                    }

                }

            ]

        },

        websiteSpeedOptimisation:{

            name:"Website Speed Optimisation",

            credits:3,

            specialistPercentage:0.65,

            support:["oneOff"],

            questions:[

                {

                    id:"speedOptimisationPages",

                    type:"single",

                    question:"How many pages should we optimise?",

                    description:"This helps us estimate the scope of the optimisation work.",

                    options:{

                        oneToFive:{

                            label:"1–5 pages",

                            multiplier:1

                        },

                        sixToTen:{

                            label:"6–10 pages",

                            multiplier:1.5

                        },

                        elevenToFifteen:{

                            label:"11–15 pages",

                            multiplier:2

                        },

                        sixteenToTwenty:{

                            label:"16–20 pages",

                            multiplier:2.5

                        }

                    }

                }

            ]

        },

        conversionRateOptimisation:{

            name:"Conversion Rate Optimisation",

            credits:3,

            specialistPercentage:0.70,

            support:["oneOff"],

            questions:[

                {

                    id:"croPages",

                    type:"single",

                    question:"How many pages should we optimise for conversion?",

                    description:"This helps us estimate the scope of the CRO work.",

                    options:{

                        oneToFive:{

                            label:"1–5 pages",

                            multiplier:1

                        },

                        sixToTen:{

                            label:"6–10 pages",

                            multiplier:1.5

                        },

                        elevenToFifteen:{

                            label:"11–15 pages",

                            multiplier:2

                        },

                        sixteenToTwenty:{

                            label:"16–20 pages",

                            multiplier:2.5

                        }

                    }

                }

            ]

        },

        websiteCopywriting:{

            name:"Website Copywriting",

            credits:3,

            specialistPercentage:0.65,

            support:["oneOff"],

            questions:[

                {

                    id:"websiteCopyPages",

                    type:"single",

                    question:"How many pages would you like copy written for?",

                    description:"This helps us estimate the amount of copywriting required.",

                    options:{

                        oneToFive:{

                            label:"1–5 pages",

                            multiplier:1

                        },

                        sixToTen:{

                            label:"6–10 pages",

                            multiplier:1.5

                        },

                        elevenToFifteen:{

                            label:"11–15 pages",

                            multiplier:2

                        },

                        sixteenToTwenty:{

                            label:"16–20 pages",

                            multiplier:2.5

                        }

                    }

                }

            ]

        }

    }

},
 // ==================================================
// E-COMMERCE
// ==================================================

"E-Commerce":{

    id:"ecommerce",

    displayName:"E-Commerce",

    tasks:{

        starterOnlineStore:{

    name:"Starter Online Store",

    specialistPercentage:0.70,

    credits:7,

    support:["oneOff"],

    questions:[

        {

            id:"starterStorePlatform",

            type:"single",

            question:"Which platform would you like your store built on?",

            description:"Choose the platform you would like us to build your online store on.",

            options:{

                shopify:{

                    label:"Shopify",

                    multiplier:1

                },

                wix:{

                    label:"Wix",

                    multiplier:1

                },

                squarespace:{

                    label:"Squarespace",

                    multiplier:1

                },

                woocommerce:{

                    label:"WooCommerce",

                    multiplier:1.25

                },

                etsy:{

                    label:"Etsy",

                    multiplier:1.5

                },

                amazon:{

                    label:"Amazon",

                    multiplier:1.75

                }

            }

        },

        {

            id:"starterStoreProducts",

            type:"single",

            question:"How many products would you like your store to include?",

            description:"This helps us estimate the store setup workload.",

            options:{

                oneToTen:{

                    label:"1–10 products",

                    multiplier:1

                },

                elevenToTwenty:{

                    label:"11–20 products",

                    multiplier:1.25

                },

                twentyOneToThirty:{

                    label:"21–30 products",

                    multiplier:1.5

                }

            }

        }

    ]

},

        productUpdates:{

    name:"Product Updates",

    credits:1,

    specialistPercentage:0.60,

    support:["oneOff"],

    questions:[

        {

            id:"productUpdatesPlatforms",

            type:"multi",

            question:"Where would you like your products updated?",

            description:"Select all platforms or sales channels where you would like us to update your products.",

            options:{

                shopify:{
                    label:"Shopify",
                    multiplier:1
                },

                wix:{
                    label:"Wix",
                    multiplier:1
                },

                squarespace:{
                    label:"Squarespace",
                    multiplier:1
                },

                woocommerce:{
                    label:"WooCommerce",
                    multiplier:1.25
                },

                etsy:{
                    label:"Etsy",
                    multiplier:1.5
                },

                tiktokShop:{
                    label:"TikTok Shop",
                    multiplier:1.5
                },

                metaShop:{
                    label:"Meta Shop",
                    multiplier:1.25
                },

                amazon:{
                    label:"Amazon",
                    multiplier:1.75
                },

                googleMerchantCentre:{
                    label:"Google Merchant Centre",
                    multiplier:1.75
                }

            }

        },

        {

            id:"productUpdatesProducts",

            type:"single",

            question:"How many products would you like updated?",

            description:"This helps us estimate the amount of product work required.",

            options:{

                oneToTen:{

                    label:"1–10 products",

                    multiplier:1

                },

                elevenToTwenty:{

                    label:"11–20 products",

                    multiplier:1.25

                },

                twentyOneToThirty:{

                    label:"21–30 products",

                    multiplier:1.5

                }

            }

        }

    ]

},

        productListing:{

    name:"Product Listing",

    credits:2,

    specialistPercentage:0.60,

    support:["oneOff"],

    questions:[

        {

            id:"productListingPlatforms",

            type:"multi",

            question:"Where would you like your products listed?",

            description:"Select all platforms or sales channels where you would like us to list your products.",

            options:{

                shopify:{

                    label:"Shopify",

                    multiplier:1

                },

                wix:{

                    label:"Wix",

                    multiplier:1

                },

                squarespace:{

                    label:"Squarespace",

                    multiplier:1

                },

                woocommerce:{

                    label:"WooCommerce",

                    multiplier:1.25

                },

                etsy:{

                    label:"Etsy",

                    multiplier:1.5

                },

                tiktokShop:{

                    label:"TikTok Shop",

                    multiplier:1.5

                },

                metaShop:{

                    label:"Meta Shop",

                    multiplier:1.25

                },

                amazon:{

                    label:"Amazon",

                    multiplier:1.75

                },

                googleMerchantCentre:{

                    label:"Google Merchant Centre",

                    multiplier:1.75

                }

            }

        },

        {

            id:"productListingProducts",

            type:"single",

            question:"How many products would you like us to list?",

            description:"This helps us estimate the product listing workload.",

            options:{

                oneToTen:{

                    label:"1–10 products",

                    multiplier:1

                },

                elevenToTwenty:{

                    label:"11–20 products",

                    multiplier:1.25

                },

                twentyOneToThirty:{

                    label:"21–30 products",

                    multiplier:1.5

                }

            }

        }

    ]

},

       ecommerceStoreRedesign:{

    name:"E-Commerce Store Redesign",

    credits:7,

    specialistPercentage:0.70,

    support:["oneOff"],

    questions:[

        {

            id:"ecommerceRedesignPlatform",

            type:"single",

            question:"Which platform would you like your store redesigned on?",

            description:"Choose the platform your e-commerce store is built on.",

            options:{

                shopify:{
                    label:"Shopify",
                    multiplier:1
                },

                wix:{
                    label:"Wix",
                    multiplier:1
                },

                squarespace:{
                    label:"Squarespace",
                    multiplier:1
                },

                woocommerce:{
                    label:"WooCommerce",
                    multiplier:1.25
                },

                etsy:{
                    label:"Etsy",
                    multiplier:1.5
                },

                amazon:{
                    label:"Amazon",
                    multiplier:1.75
                }

            }

        },

        {

            id:"ecommerceRedesignPages",

            type:"single",

            question:"How many pages would you like redesigned?",

            description:"This helps us estimate the amount of redesign work required.",

            options:{

                oneToFive:{

                    label:"1–5 pages",

                    multiplier:1

                },

                sixToTen:{

                    label:"6–10 pages",

                    multiplier:1.5

                },

                elevenToFifteen:{

                    label:"11–15 pages",

                    multiplier:2

                },

                sixteenToTwenty:{

                    label:"16–20 pages",

                    multiplier:2.5

                }

            }

        }

    ]

},

        productPageOptimisation:{

    name:"Product Page Optimisation",

    credits:2,

    specialistPercentage:0.65,

    support:["oneOff"],

    questions:[

        {

            id:"productPageOptimisationPlatforms",

            type:"multi",

            question:"Where would you like your product pages optimised?",

            description:"Select all platforms or sales channels where you would like us to optimise your product pages.",

            options:{

                shopify:{
                    label:"Shopify",
                    multiplier:1
                },

                wix:{
                    label:"Wix",
                    multiplier:1
                },

                squarespace:{
                    label:"Squarespace",
                    multiplier:1
                },

                woocommerce:{
                    label:"WooCommerce",
                    multiplier:1.25
                },

                etsy:{
                    label:"Etsy",
                    multiplier:1.5
                },

                tiktokShop:{
                    label:"TikTok Shop",
                    multiplier:1.5
                },

                metaShop:{
                    label:"Meta Shop",
                    multiplier:1.25
                },

                amazon:{
                    label:"Amazon",
                    multiplier:1.75
                },

                googleMerchantCentre:{
                    label:"Google Merchant Centre",
                    multiplier:1.75
                }

            }

        },

        {

            id:"productPageOptimisationProducts",

            type:"single",

            question:"How many products would you like us to optimise?",

            description:"This helps us estimate the amount of product optimisation work required.",

            options:{

                oneToTen:{

                    label:"1–10 products",

                    multiplier:1

                },

                elevenToTwenty:{

                    label:"11–20 products",

                    multiplier:1.5

                },

                twentyOneToThirty:{

                    label:"21–30 products",

                    multiplier:2

                }

            }

        }

    ]

},

        collectionCategorySetup:{

    name:"Collection / Category Setup",

    credits:2,

    specialistPercentage:0.60,

    support:["oneOff"],

    questions:[

        {

            id:"collectionCategories",

            type:"single",

            question:"How many collections or categories would you like us to create?",

            description:"Create and organise collections or categories to make your existing products easier for customers to browse.",

            options:{

                oneToFive:{

                    label:"1–5 collections/categories",

                    multiplier:1

                },

                sixToTen:{

                    label:"6–10 collections/categories",

                    multiplier:1.5

                },

                elevenToFifteen:{

                    label:"11–15 collections/categories",

                    multiplier:2

                },

                sixteenToTwenty:{

                    label:"16–20 collections/categories",

                    multiplier:2.5

                }

            }

        }

    ]

},

        ecommerceSeoSetup:{

            name:"E-Commerce SEO Setup",

            credits:3,

            specialistPercentage:0.65,

            support:["oneOff"],

            questions:[

                {

                    id:"ecommerceSeoProducts",

                    type:"single",

                    question:"How many products should the SEO setup cover?",

                    description:"This helps us estimate the scope of the e-commerce SEO work.",

                    options:{

                        oneToTen:{

                            label:"1–10 products",

                            multiplier:1

                        },

                        elevenToTwenty:{

                            label:"11–20 products",

                            multiplier:1.5

                        },

                        twentyOneToThirty:{

                            label:"21–30 products",

                            multiplier:2

                        }

                    }

                }

            ]

        },


    }

},

// ==================================================
// SOCIAL MEDIA MARKETING
// ==================================================

"Social Media Marketing":{

    id:"socialMedia",

    displayName:"Social Media",

    tasks:{

        socialMediaAudit:{
            name:"Social Media Audit",
            credits:2,
            specialistPercentage:0.65,
            support:["oneOff"],
            questions:[
                {
                    id:"socialAuditPlatforms",
                    type:"multi",
                    question:"Which social media platforms should the audit cover?",
                    description:"Select all platforms that apply.",
                    options:{
                        instagram:{label:"Instagram",multiplier:1},
                        facebook:{label:"Facebook",multiplier:1.25},
                        tiktok:{label:"TikTok",multiplier:1.5},
                        linkedin:{label:"LinkedIn",multiplier:1.75}
                    }
                }
            ]
        },

        postCreation:{
            name:"Post Creation",
            credits:1,
            specialistPercentage:0.60,
            support:["oneOff"],
            questions:[
                {
                    id:"postCreationPlatforms",
                    type:"multi",
                    question:"Which social media platforms would you like the posts created for?",
                    description:"Select all platforms that apply.",
                    options:{
                        instagram:{label:"Instagram",multiplier:1},
                        facebook:{label:"Facebook",multiplier:1.25},
                        tiktok:{label:"TikTok",multiplier:1.5},
                        linkedin:{label:"LinkedIn",multiplier:1.75}
                    }
                },
                {
                    id:"postCreationQuantity",
                    type:"single",
                    question:"How many social media posts would you like created?",
                    description:"This helps us estimate the content creation workload.",
                    options:{
                        oneToFive:{label:"1–5 posts",multiplier:1},
                        sixToTen:{label:"6–10 posts",multiplier:1.5},
                        elevenToFifteen:{label:"11–15 posts",multiplier:2},
                        sixteenToTwenty:{label:"16–20 posts",multiplier:2.5}
                    }
                }
            ]
        },

        contentPlanCreation:{
            name:"Content Plan Creation",
            credits:3,
            specialistPercentage:0.65,
            support:["oneOff"],
            questions:[
                {
                    id:"contentPlanPlatforms",
                    type:"multi",
                    question:"Which social media platforms should the content plan cover?",
                    description:"Select all platforms that apply.",
                    options:{
                        instagram:{label:"Instagram",multiplier:1},
                        facebook:{label:"Facebook",multiplier:1.25},
                        tiktok:{label:"TikTok",multiplier:1.5},
                        linkedin:{label:"LinkedIn",multiplier:1.75}
                    }
                },
                {
                    id:"contentPlanPeriod",
                    type:"single",
                    question:"How many months should the content plan cover?",
                    description:"Select the planning period required.",
                    options:{
                        oneMonth:{label:"1 month",multiplier:1},
                        threeMonths:{label:"3 months",multiplier:1.5},
                        sixMonths:{label:"6 months",multiplier:2}
                    }
                }
            ]
        },

        socialMediaStrategy:{
            name:"Social Media Strategy",
            credits:3,
            specialistPercentage:0.70,
            support:["oneOff"],
            questions:[
                {
                    id:"socialStrategyPlatforms",
                    type:"multi",
                    question:"Which social media platforms should the strategy cover?",
                    description:"Select all platforms that apply.",
                    options:{
                        instagram:{label:"Instagram",multiplier:1},
                        facebook:{label:"Facebook",multiplier:1.25},
                        tiktok:{label:"TikTok",multiplier:1.5},
                        linkedin:{label:"LinkedIn",multiplier:1.75}
                    }
                }
            ]
        },

        profileOptimisation:{
            name:"Profile Optimisation",
            credits:2,
            specialistPercentage:0.60,
            support:["oneOff"],
            questions:[
                {
                    id:"profileOptimisationPlatforms",
                    type:"multi",
                    question:"Which social media platforms would you like your profiles optimised for?",
                    description:"Select all platforms that apply.",
                    options:{
                        instagram:{label:"Instagram",multiplier:1},
                        facebook:{label:"Facebook",multiplier:1.25},
                        tiktok:{label:"TikTok",multiplier:1.5},
                        linkedin:{label:"LinkedIn",multiplier:1.75}
                    }
                }
            ]
        },

        socialMediaLaunchPackage:{
            name:"Social Media Launch Package",
            credits:4,
            specialistPercentage:0.70,
            support:["oneOff"],
            questions:[
                {
                    id:"launchPackagePlatforms",
                    type:"multi",
                    question:"Which social media platforms should the launch package cover?",
                    description:"Select all platforms that apply.",
                    options:{
                        instagram:{label:"Instagram",multiplier:1},
                        facebook:{label:"Facebook",multiplier:1.25},
                        tiktok:{label:"TikTok",multiplier:1.5},
                        linkedin:{label:"LinkedIn",multiplier:1.75}
                    }
                }
            ]
        },

        reelsShortFormVideo:{
            name:"Reels / Short-Form Video Creation",
            credits:2,
            specialistPercentage:0.65,
            support:["oneOff"],
            questions:[
                {
                    id:"shortFormVideoPlatforms",
                    type:"multi",
                    question:"Which social media platforms would you like the videos created for?",
                    description:"Select all platforms that apply.",
                    options:{
                        instagram:{label:"Instagram",multiplier:1},
                        facebook:{label:"Facebook",multiplier:1.25},
                        tiktok:{label:"TikTok",multiplier:1.5},
                        linkedin:{label:"LinkedIn",multiplier:1.75}
                    }
                },
                {
                    id:"shortFormVideos",
                    type:"single",
                    question:"How many short-form videos would you like created?",
                    description:"This helps us estimate the video production workload.",
                    options:{
                        oneToFive:{label:"1–5 videos",multiplier:1},
                        sixToTen:{label:"6–10 videos",multiplier:1.5},
                        elevenToFifteen:{label:"11–15 videos",multiplier:2},
                        sixteenToTwenty:{label:"16–20 videos",multiplier:2.5}
                    }
                }
            ]
        },

        socialMediaCampaign:{
            name:"Social Media Campaign",
            credits:3,
            specialistPercentage:0.70,
            support:["oneOff"],
            questions:[
                {
                    id:"socialCampaignPlatforms",
                    type:"multi",
                    question:"Which social media platforms should the campaign cover?",
                    description:"Select all platforms that apply.",
                    options:{
                        instagram:{label:"Instagram",multiplier:1},
                        facebook:{label:"Facebook",multiplier:1.25},
                        tiktok:{label:"TikTok",multiplier:1.5},
                        linkedin:{label:"LinkedIn",multiplier:1.75}
                    }
                }
            ]
        },

        influencerCreatorStrategy:{
            name:"Influencer / Creator Strategy",
            credits:3,
            specialistPercentage:0.70,
            support:["oneOff"],
            questions:[
                {
                    id:"influencerPlatforms",
                    type:"multi",
                    question:"Which social media platforms should the strategy focus on?",
                    description:"Select all platforms that apply.",
                    options:{
                        instagram:{label:"Instagram",multiplier:1},
                        tiktok:{label:"TikTok",multiplier:1.5}
                    }
                },
                {
                    id:"influencerCreators",
                    type:"single",
                    question:"How many influencers or creators should the strategy consider?",
                    description:"This helps us estimate the research and strategy workload.",
                    options:{
                        oneToTen:{label:"1–10 creators",multiplier:1},
                        elevenToTwenty:{label:"11–20 creators",multiplier:1.5},
                        twentyOneToThirty:{label:"21–30 creators",multiplier:2}
                    }
                }
            ]
        }

    }

},

// ==================================================
// GRAPHIC DESIGN
// ==================================================
"Graphic Design":{

    id:"graphicDesign",

    displayName:"Design",

    tasks:{

        logoDesign:{

            name:"Logo Design",

            credits:3,

            specialistPercentage:0.70,

            support:["oneOff"],

            questions:[

                {

                    id:"logoConcepts",

                    type:"single",

                    question:"How many logo concepts would you like?",

                    description:"This helps us estimate the amount of creative exploration required.",

                    options:{

                        one:{

                            label:"1 concept",

                            multiplier:1

                        },

                        two:{

                            label:"2 concepts",

                            multiplier:1.5

                        },

                        three:{

                            label:"3 concepts",

                            multiplier:2

                        }

                    }

                },

                {

                    id:"logoType",

                    type:"single",

                    question:"What type of logo are you looking for?",

                    description:"Choose the style that best matches what you have in mind.",

                    options:{

                        wordmark:{

                            label:"Wordmark",

                            multiplier:1

                        },

                        lettermark:{

                            label:"Lettermark",

                            multiplier:1.25

                        },

                        symbol:{

                            label:"Symbol",

                            multiplier:1.75

                        },

                        combination:{

                            label:"Combination",

                            multiplier:2

                        },

                        emblem:{

                            label:"Emblem",

                            multiplier:2

                        },

                        threeD:{

                            label:"3D Logo",

                            multiplier:2.25

                        },

                        abstract:{

                            label:"Abstract",

                            multiplier:2.5

                        }

                    }

                }

            ]

        },

        packagingMerchandiseDesign:{

            name:"Packaging / Merchandise Design",

            credits:5,

            specialistPercentage:0.70,

            support:["oneOff"],

            questions:[

                {

                    id:"packagingItems",

                    type:"single",

                    question:"How many packaging or merchandise items would you like designed?",

                    description:"This helps us estimate the design workload.",

                    options:{

                        one:{

                            label:"1 item",

                            multiplier:1

                        },

                        twoToFive:{

                            label:"2–5 items",

                            multiplier:1.5

                        },

                        sixToTen:{

                            label:"6–10 items",

                            multiplier:2

                        }

                    }

                }

            ]

        },

        socialChannelDesign:{

            name:"Social Media / Channel Design",

            credits:2,

            specialistPercentage:0.65,

            support:["oneOff"],

            questions:[

                {

                    id:"socialChannelItems",

                    type:"single",

                    question:"How many social media or channel assets would you like designed?",

                    description:"This helps us estimate the creative workload.",

                    options:{

                        oneToFive:{

                            label:"1–5 assets",

                            multiplier:1

                        },

                        sixToTen:{

                            label:"6–10 assets",

                            multiplier:1.5

                        },

                        elevenToFifteen:{

                            label:"11–15 assets",

                            multiplier:2

                        },

                        sixteenToTwenty:{

                            label:"16–20 assets",

                            multiplier:2.5

                        }

                    }

                }

            ]

        },

        businessCardDesign:{

            name:"Business Card Design",

            credits:1,

            specialistPercentage:0.60,

            support:["oneOff"],

            questions:[

                {

                    id:"businessCardItems",

                    type:"single",

                    question:"How many business card designs would you like?",

                    description:"This helps us estimate the design workload.",

                    options:{

                        one:{

                            label:"1 design",

                            multiplier:1

                        },

                        two:{

                            label:"2 designs",

                            multiplier:1.5

                        },

                        three:{

                            label:"3 designs",

                            multiplier:2

                        }

                    }

                }

            ]

        },

        flyerPosterDesign:{

            name:"Flyer / Poster Design",

            credits:2,

            specialistPercentage:0.60,

            support:["oneOff"],

            questions:[

                {

                    id:"flyerPosterItems",

                    type:"single",

                    question:"How many flyer or poster designs would you like?",

                    description:"This helps us estimate the design workload.",

                    options:{

                        one:{

                            label:"1 design",

                            multiplier:1

                        },

                        twoToFive:{

                            label:"2–5 designs",

                            multiplier:1.5

                        },

                        sixToTen:{

                            label:"6–10 designs",

                            multiplier:2

                        }

                    }

                }

            ]

        },

        presentationDesign:{

            name:"Presentation Design",

            credits:3,

            specialistPercentage:0.65,

            support:["oneOff"],

            questions:[

                {

                    id:"presentationSlides",

                    type:"single",

                    question:"How many slides would you like designed?",

                    description:"This helps us estimate the presentation design workload.",

                    options:{

                        oneToFive:{

                            label:"1–5 slides",

                            multiplier:1

                        },

                        sixToTen:{

                            label:"6–10 slides",

                            multiplier:1.5

                        },

                        elevenToFifteen:{

                            label:"11–15 slides",

                            multiplier:2

                        },

                        sixteenToTwenty:{

                            label:"16–20 slides",

                            multiplier:2.5

                        }

                    }

                }

            ]

        },

        adCreativeDesign:{

            name:"Ad Creative Design",

            credits:2,

            specialistPercentage:0.70,

            support:["oneOff"],

            questions:[

                {

                    id:"adCreativeQuantity",

                    type:"single",

                    question:"How many ad creatives would you like designed?",

                    description:"This helps us estimate the creative production workload.",

                    options:{

                        oneToFive:{

                            label:"1–5 creatives",

                            multiplier:1

                        },

                        sixToTen:{

                            label:"6–10 creatives",

                            multiplier:1.5

                        },

                        elevenToFifteen:{

                            label:"11–15 creatives",

                            multiplier:2

                        },

                        sixteenToTwenty:{

                            label:"16–20 creatives",

                            multiplier:2.5

                        }

                    }

                }

            ]

        },

        emailDesign:{

            name:"Email Design",

            credits:2,

            specialistPercentage:0.65,

            support:["oneOff"],

            questions:[

                {

                    id:"emailDesignQuantity",

                    type:"single",

                    question:"How many email designs would you like?",

                    description:"This helps us estimate the design workload.",

                    options:{

                        one:{

                            label:"1 design",

                            multiplier:1

                        },

                        twoToFive:{

                            label:"2–5 designs",

                            multiplier:1.5

                        },

                        sixToTen:{

                            label:"6–10 designs",

                            multiplier:2

                        },

                        elevenToFifteen:{

                            label:"11–15 designs",

                            multiplier:2.5

                        }

                    }

                }

            ]

        }

    }

},

}

};

// ======================================================

// CALCULATOR STATE
// ======================================================

const state = {

    supportType:"oneOff",

    selectedServices:[],

    selectedTasks:{},

    answers:{},

    questionQueue:[],

    currentQuestion:0,

    quote:null

};

// ======================================================
// SCREEN NAVIGATION
// ======================================================

let currentScreen = 1;

function nextScreen(){

    showScreen(currentScreen + 1);

}

function previousScreen(){

    if(currentScreen > 1){

        showScreen(currentScreen - 1);

    }

}

// ======================================================

// SERVICE SELECTION

// ======================================================

function selectService(card,service){

    const index =

        state.selectedServices.indexOf(service);

    if(index === -1){

        state.selectedServices.push(service);

        card.classList.add("selected");

    }

    else{

        state.selectedServices.splice(index,1);

        card.classList.remove("selected");

    }

    document

        .getElementById("servicesContinue")

        .disabled =

        state.selectedServices.length === 0;


    const serviceSelectionSummary =
        document.getElementById(
            "serviceSelectionSummary"
        );

    if(serviceSelectionSummary){

        const count =
            state.selectedServices.length;

        serviceSelectionSummary.textContent =
            count === 1
                ? "1 service selected"
                : `${count} services selected`;

        serviceSelectionSummary.classList.toggle(
            "selected",
            count > 0
        );

    }

}

// ======================================================

// CONTINUE FROM SERVICES

// ======================================================

function continueFromServices(){

    if(state.selectedServices.length === 0){

        return;

    }

    startTaskFlow();

}

// ======================================================

// BUILD TASK SCREENS

// ======================================================

function buildTaskScreens(){

    state.selectedTasks = {};

    state.selectedServices.forEach(service=>{

        state.selectedTasks[service] = [];

    });

}

// ======================================================
// LOAD TASKS
// ======================================================

function loadTasks(service){

    const serviceConfig =
        CONFIG.services[service];

    if(!serviceConfig){

        return;

    }

    document.getElementById("dynamicQuestion").textContent =

        `${serviceConfig.displayName} Tasks`;

    document.getElementById("dynamicDescription").textContent =

        "Select all tasks you require.";

    const container =
    document.getElementById("dynamicOptions");

container.innerHTML = "";

const taskSummary =
    document.getElementById("taskSelectionSummary");

if(taskSummary){

    taskSummary.innerHTML = "";

    taskSummary.classList.remove(
        "expanded"
    );

}

    // ==================================================
    // TASK CATEGORIES
    // ==================================================

    const taskCategories = {

        "SEO":{

            "Technical & On-Page":[
                "Technical SEO Audit",
                "On-page Optimisation",
                "Internal Linking Optimisation"
            ],

            "Research & Content":[
                "Keyword Research",
                "SEO Competitor Analysis",
                "SEO Content Strategy",
                "Landing Page Copy",
                "Blog Creation"
            ],

            "Local & Reporting":[
                "SEO Platform Integration",
                "SEO Reporting Setup",
                "SEO Migration Support",
                "Google Business Profile Setup",
                "Local Citation Building"
            ]

        },

        "PPC":{

            "Campaigns":[
                "New Campaign Setup",
                "PPC Account Restructure",
                "Shopping Campaign Setup"
            ],

            "Strategy & Creative":[
                "PPC Audit",
                "Keyword Research & Strategy",
                "Ad Copy Creation",
                "Audience & Targeting Setup"
            ],

            "Tracking & Optimisation":[
                "Conversion Tracking",
                "Landing Page Audit"
            ]

        },

        "Website Creation":{

            "Website":[
                "Starter Website",
                "Landing Page Creation",
                "Website Redesign",
                "Website Migration"
            ],

            "Optimisation":[
                "UX & Performance Audit",
                "Website Speed Optimisation",
                "Conversion Rate Optimisation"
            ],

            "Content":[
                "Website Copywriting"
            ]

        },

"E-Commerce":{

    "Store Build & Design":[
        "Starter Online Store",
        "E-Commerce Store Redesign"
    ],

    "Products & Catalogue":[
        "Product Updates",
        "Product Listing",
        "Collection / Category Setup"
    ],

    "Optimisation":[
        "Product Page Optimisation",
        "E-Commerce SEO Setup"
    ]

},

        "Social Media Marketing":{

            "Strategy & Profiles":[
                "Social Media Audit",
                "Social Media Strategy",
                "Profile Optimisation",
                "Influencer / Creator Strategy"
            ],

            "Content":[
                "Post Creation",
                "Content Plan Creation",
                "Reels / Short-Form Video Creation"
            ],

            "Campaigns":[
                "Social Media Launch Package",
                "Social Media Campaign"
            ]

        },

        "Graphic Design":{

            "Brand & Packaging":[
                "Logo Design",
                "Packaging / Merchandise Design"
            ],

            "Digital Design":[
                "Social Media / Channel Design",
                "Ad Creative Design",
                "Email Design"
            ],

            "Print & Presentation":[
                "Business Card Design",
                "Flyer / Poster Design",
                "Presentation Design"
            ]

        }

    };

    // ==================================================
    // AVAILABLE TASKS
    // ==================================================

    const availableTasks = [];

    Object.values(serviceConfig.tasks).forEach(task=>{

        if(

            task.support &&

            !task.support.includes("oneOff")

        ){

            return;

        }

        availableTasks.push(task);

    });

    // ==================================================
    // CATEGORIES
    // ==================================================

    const categories =
        taskCategories[service];

    // If no categories exist, use the
    // original task display

    if(!categories){

        availableTasks.forEach(task=>{

            const card =
                document.createElement("div");

            card.className = "option";

            card.textContent =
                task.name;

            if(
                state.selectedTasks[service]
                .includes(task.name)
            ){

                card.classList.add("selected");

            }

            card.onclick = ()=>{

                toggleTask(
                    service,
                    task.name,
                    card
                );

            };

            container.appendChild(card);

        });

    }

    else{

        // ==================================================
        // CATEGORY TABS
        // ==================================================

        const categoryTabs =
            document.createElement("div");

        categoryTabs.className =
            "task-category-tabs";

        container.appendChild(
            categoryTabs
        );


        // ==================================================
        // TASK LIST
        // ==================================================

        const taskList =
            document.createElement("div");

        taskList.className =
            "task-category-list";

        container.appendChild(
            taskList
        );


        // ==================================================
        // RENDER CATEGORY
        // ==================================================

        function renderCategory(categoryName){

            taskList.innerHTML = "";

            categoryTabs
                .querySelectorAll(
                    ".task-category-tab"
                )
                .forEach(tab=>{

                    tab.classList.remove(
                        "active"
                    );

                });


            const activeTab =
                categoryTabs.querySelector(
                    `[data-category="${categoryName}"]`
                );


            if(activeTab){

                activeTab.classList.add(
                    "active"
                );

            }


            const categoryTasks =
                categories[categoryName] || [];


            categoryTasks.forEach(taskName=>{

                const task =
                    availableTasks.find(
                        item =>
                            item.name === taskName
                    );


                if(!task){

                    return;

                }


                const card =
                    document.createElement("div");

                card.className =
                    "option";

                card.textContent =
                    task.name;


                if(

                    state.selectedTasks[service]

                    .includes(task.name)

                ){

                    card.classList.add(
                        "selected"
                    );

                }


                card.onclick = ()=>{

                    toggleTask(
                        service,
                        task.name,
                        card
                    );

                };


                taskList.appendChild(
                    card
                );

            });

        }


        // ==================================================
        // CREATE CATEGORY TABS
        // ==================================================

        Object.keys(categories)
            .forEach(
                (categoryName,index)=>{

                    const tab =
                        document.createElement(
                            "button"
                        );

                    tab.type =
                        "button";

                    tab.className =
                        "task-category-tab";

                    tab.textContent =
                        categoryName;

                    tab.dataset.category =
                        categoryName;


                    tab.onclick = ()=>{

                        renderCategory(
                            categoryName
                        );

                    };


                    categoryTabs.appendChild(
                        tab
                    );


                    // Show first category
                    // automatically

                    if(index === 0){

                        renderCategory(
                            categoryName
                        );

                    }

                }
            );

    }


    // ==================================================
    // CONTINUE BUTTON
    // ==================================================

    document
    .getElementById(
        "dynamicContinue"
    )
    .disabled =

    state.selectedTasks[service]
    .length === 0;

updateTaskSelectionSummary();

}

// ======================================================
// TOGGLE TASK
// ======================================================

function toggleTask(service, taskName, card){

    const selectedTasks =
        state.selectedTasks[service];

    if(!selectedTasks){
        return;
    }

    const index =
        selectedTasks.indexOf(taskName);

    if(index === -1){

        selectedTasks.push(taskName);

        card.classList.add("selected");

    }

    else{

        selectedTasks.splice(
            index,
            1
        );

        card.classList.remove("selected");

    }

    document
        .getElementById("dynamicContinue")
        .disabled =
        selectedTasks.length === 0;

    updateTaskSelectionSummary(service);

}


function updateTaskSelectionSummary(service){

    const summary =
        document.getElementById(
            "taskSelectionSummary"
        );

    if(!summary){
        return;
    }

    // ------------------------------------------
    // GET ALL SELECTED TASKS ACROSS SERVICES
    // ------------------------------------------

    const allSelectedTasks = [];

    state.selectedServices.forEach(selectedService => {

        const selectedTasks =
            state.selectedTasks[selectedService] || [];

        selectedTasks.forEach(task => {

            allSelectedTasks.push({
                service:selectedService,
                task:task
            });

        });

    });


    // ------------------------------------------
    // HIDE SUMMARY IF FEWER THAN 2 TASKS
    // ------------------------------------------

    if(allSelectedTasks.length < 2){

        summary.innerHTML = "";

        summary.classList.remove(
            "expanded"
        );

        return;

    }


    // ------------------------------------------
    // BUILD SUMMARY
    // ------------------------------------------

    summary.innerHTML = `

        <button
            type="button"
            class="task-selection-toggle"
            onclick="toggleTaskSelectionSummary()">

            <span>
                ${allSelectedTasks.length} tasks selected
            </span>

            <span class="task-selection-chevron">
                ›
            </span>

        </button>

        <div class="task-selection-details">

            ${allSelectedTasks.map(item => `

                <div class="task-selection-item">

                    <span class="task-selection-check">
                        ✓
                    </span>

                    <span>

                        <strong>
                            ${CONFIG.services[item.service].displayName}
                        </strong>

                        <small>
                            ${item.task}
                        </small>

                    </span>

                </div>

            `).join("")}

        </div>

    `;

}


function toggleTaskSelectionSummary(){

    const summary =
        document.getElementById(
            "taskSelectionSummary"
        );

    if(!summary){
        return;
    }

    summary.classList.toggle(
        "expanded"
    );

}

// ======================================================

// QUOTE BREAKDOWN

// ======================================================

function buildQuoteBreakdown(){

    const breakdown = [];

    state.selectedServices.forEach(service=>{

        const serviceConfig =
            CONFIG.services[service];

        const selectedTasks =
            state.selectedTasks[service];

        Object.values(serviceConfig.tasks).forEach(task=>{

       if(!selectedTasks.includes(task.name)){
    return;
}
            let credits =
                task.credits;

            task.questions.forEach(question=>{

                const answer =
                    state.answers[question.id];

                if(!answer){
                    return;
                }

                if(question.type === "single"){

                    const option =
                        Object.values(question.options)
                        .find(option=>option.label===answer);

                    if(option){

                        credits *= option.multiplier;

                    }

                }

                else{

                    answer.forEach(selected=>{

                        const option =
                            Object.values(question.options)
                            .find(option=>option.label===selected);

                        if(option){

                            credits *= option.multiplier;

                        }

                    });

                }

            });

            breakdown.push({

                service,

                task:task.name,

                credits:Math.ceil(credits)

            });

        });

    });

    state.quote.breakdown = breakdown;

}
// ======================================================
// FINALISE QUOTE
// ======================================================

function finaliseQuote(){

    // Make sure the quote object exists
    if(!state.quote){

        state.quote = {

            credits:0,

            pricePerCredit:
    CONFIG.creditValues.oneOff,

            total:0

        };

    }

    // Build the task-level quote first
    buildQuoteBreakdown();

     // Base credits from selected tasks

    state.quote.subtotal =

        state.quote.breakdown.reduce(

            (total,item) =>

                total + item.credits,

            0

        );

    // Calculate final project price

    state.quote.credits =

        Math.ceil(state.quote.subtotal);

    state.quote.total =

        state.quote.credits *

        state.quote.pricePerCredit;

       // Payment structure will be calculated
    // after the final complexity-adjusted price

    // ------------------------------------------
    // BUSINESS SIZE MULTIPLIER
    // ------------------------------------------

    const businessSizeOption =
        Object.values(
            CONFIG.globalQuestions
                .businessSize
                .options
        ).find(
            option =>
                option.label ===
                state.answers.businessSize
        );

    const businessSizeMultiplier =
        businessSizeOption?.multiplier || 1;


    // ------------------------------------------
    // COUNTRIES MULTIPLIER
    // ------------------------------------------

    const countriesOption =
        Object.values(
            CONFIG.globalQuestions
                .countries
                .options
        ).find(
            option =>
                option.label ===
                state.answers.countries
        );

    const countriesMultiplier =
        countriesOption?.multiplier || 1;


    // ------------------------------------------
    // MARKETING BUDGET MULTIPLIER
    // ------------------------------------------

    const marketingBudgetOption =
        Object.values(
            CONFIG.globalQuestions
                .marketingBudget
                .options
        ).find(
            option =>
                option.label ===
                state.answers.marketingBudget
        );

    const marketingBudgetMultiplier =
        marketingBudgetOption?.multiplier || 1;


    // ------------------------------------------
    // OVERALL COMPLEXITY
    // ------------------------------------------

    const complexityMultiplier =
        businessSizeMultiplier *
        countriesMultiplier *
        marketingBudgetMultiplier;


    // ------------------------------------------
    // APPLY COMPLEXITY
    // ------------------------------------------

    state.quote.totalCredits =
        Math.ceil(
            state.quote.subtotal *
            complexityMultiplier
        );


    // ------------------------------------------

    // FINAL PRICE

    // ------------------------------------------

    state.quote.totalPrice =

        state.quote.totalCredits *

        state.quote.pricePerCredit;


    // ------------------------------------------

    // PAYMENT STRUCTURE

    // ------------------------------------------

    if(

        state.quote.totalPrice <=

        CONFIG.payment.depositThreshold

    ){

        state.quote.paymentType = "full";

        state.quote.depositPercentage = 100;

        state.quote.depositAmount =

            state.quote.totalPrice;

        state.quote.balanceAmount = 0;

    }

    else{

        state.quote.paymentType = "deposit";

        state.quote.depositPercentage =

            CONFIG.payment.depositPercentage;

      state.quote.depositAmount =
    Math.round(
        state.quote.totalPrice *
        (
            state.quote.depositPercentage /
            100
        ) *
        100
    ) / 100;

        state.quote.balanceAmount =

            state.quote.totalPrice -

            state.quote.depositAmount;

    }

}
// ======================================================
// FORMAT CURRENCY
// ======================================================

function formatCurrency(value){

    return new Intl.NumberFormat(

        "en-GB",

        {

            style:"currency",

            currency:"GBP",

            maximumFractionDigits:2

        }

    ).format(value);

}
// ======================================================
// FORMAT NUMBER
// ======================================================

function formatNumber(value){

    return new Intl.NumberFormat(

        "en-GB"

    ).format(value);

}
// ======================================================
// GENERATE SUMMARY
// ======================================================

async function generateSummary(){

    finaliseQuote();

    try{

        if(!state.quote.quoteId){

            await saveQuoteToBackend();

            console.log(
                "Quote saved:",
                state.quote.quoteId
            );

        }

    }catch(error){

        console.error(
            "Quote save error:",
            error
        );

    }

    const summary =
        document.getElementById("summary");

    let html = "";

    // ==================================================
    // HEADER
    // ==================================================

html += `

        <div class="summary-header">

            <p>
                One-Off Project
            </p>

            ${
                state.quote.quoteId
                    ? `
                        <small class="quote-id">
                            Quote ID: ${state.quote.quoteId}
                        </small>
                    `
                    : ""
            }

        </div>

    `;

  // ==================================================
// SELECTED SERVICES & TASKS
// ==================================================

    // ==================================================
    // TASK BREAKDOWN
    // ==================================================

html += `

    <div class="summary-section">

        <h3>Selected Services</h3>

`;

state.quote.breakdown.forEach(item=>{

    const serviceConfig =
        CONFIG.services[item.service];

    const selectedTask =
        Object.values(serviceConfig.tasks)
        .find(task => task.name === item.task);

    let taskDetails = "";

    if(
        selectedTask &&
        Array.isArray(selectedTask.questions)
    ){

        selectedTask.questions.forEach(question=>{

            const answer =
                state.answers[question.id];

            if(!answer){
                return;
            }

            if(Array.isArray(answer)){

                answer.forEach(value=>{

                    taskDetails += `

                        <small class="task-detail">
                            ${value}
                        </small>

                    `;

                });

            }
            else{

                taskDetails += `

                    <small class="task-detail">
                        ${answer}
                    </small>

                `;

            }

        });

    }

    html += `

        <div class="summary-row">

            <span>

                <strong class="summary-service">
                    ${item.service}
                </strong>

                <small class="summary-task">
                    ${item.task}
                </small>

                ${taskDetails}

            </span>

            <strong>
                ${item.credits} Credits
            </strong>

        </div>

    `;

});

html += `

    </div>

`;

    // ==================================================
    // TOTALS
    // ==================================================

    html += `

        <div class="summary-total">

            <div class="summary-row">

                <span>Total Credits</span>

                <strong>

                    ${formatNumber(

                        state.quote.totalCredits

                    )}

                </strong>

            </div>

            <div class="summary-row">

                <span>Price Per Credit</span>

                <strong>

                    ${formatCurrency(

                        state.quote.pricePerCredit

                    )}

                </strong>

            </div>

            <div class="summary-row grand-total">

                <span>Total Project Value</span>

                <strong>

                    ${formatCurrency(

                        state.quote.totalPrice

                    )}

                </strong>

            </div>


            <div class="summary-row">

                <span>

                    Amount Due Today

                    <small>

                        ${state.quote.paymentType === "full"

                            ? "100% payment"

                            : "30% deposit — payment due today"}

                    </small>

                </span>

                <strong>

                    ${formatCurrency(

                        state.quote.depositAmount

                    )}

                </strong>

            </div>


            <div class="summary-row">

                <span>

                    Remaining Balance

                    <small>

                        ${state.quote.paymentType === "full"

                            ? "No balance remaining"

                            : "Due after project completion"}

                    </small>

                </span>

                <strong>

                    ${formatCurrency(

                        state.quote.balanceAmount

                    )}

                </strong>

            </div>


            ${

                state.quote.totalCredits > state.quote.subtotal

                ? `

                    <p class="complexity-note">

                        Your estimate includes a tailored complexity adjustment based on your requirements, adding

                        ${state.quote.totalCredits - state.quote.subtotal}

                        additional ${state.quote.totalCredits - state.quote.subtotal === 1 ? "credit" : "credits"}

                        to the base estimate.

                    </p>

                `

                : ""

            }

        </div>

    `;

    summary.innerHTML = html;

}

// ======================================================
// INITIALISE CALCULATOR
// ======================================================

document.addEventListener("DOMContentLoaded", async () => {

    // Show first screen

    showScreen(1);

    // Reset progress

    const progressBar =

        document.getElementById("progressBar");

    if(progressBar){

        progressBar.style.width = "0%";

    }

    const progressLabel =

        document.getElementById("progressLabel");

    if(progressLabel){

        progressLabel.innerHTML = "Step 1";

    }

    // Load saved quote from URL

const urlParams =
    new URLSearchParams(
        window.location.search
    );

const savedQuoteId =
    urlParams.get("quote");

if(savedQuoteId){

    try{

        console.log(
            "Loading saved quote:",
            savedQuoteId
        );

        await loadSavedQuote(
            savedQuoteId
        );

        console.log(
            "Saved quote loaded:",
            state.quote
        );

        await generateSummary();

        showScreen(6);

        updateProgress();

    }catch(error){

        console.error(
            "Saved quote loading error:",
            error
        );

        alert(
            "We couldn't load this quote. Please check the Quote ID and try again."
        );

    }

}

// Payment button

const enquireButton =
    document.getElementById("enquireButton");

if(enquireButton){

    enquireButton.addEventListener("click", async () => {

        if(!state.quote){
            return;
        }

        enquireButton.disabled = true;
        enquireButton.textContent = "Preparing Payment...";

        try{

            const result =
                await sendQuoteToBackend();

            console.log(
                "Backend response:",
                result
            );

            if(
                !result ||
                !result.success ||
                !result.quote
            ){
                throw new Error(
                    "Trusted quote was not returned"
                );
            }

            console.log(
                "Trusted quote accepted:",
                state.quote
            );

const quoteId =
    result.quoteId ||
    state.quote?.quoteId;

if(!quoteId){

    throw new Error(
        "Quote ID was not available"
    );

}

window.location.href =
    `/cart?quote=${encodeURIComponent(quoteId)}`;

        } catch(error){

            console.error(
                "Payment error:",
                error
            );

            alert(
                "Something went wrong. Please try again."
            );

        } finally{

            enquireButton.disabled = false;
            enquireButton.textContent = "Pay Now";

        }

    });

}


const emailQuoteButton =
    document.getElementById("emailQuoteButton");

if(emailQuoteButton){

    emailQuoteButton.addEventListener("click", async () => {

        if(!state.quote){
            return;
        }

        emailQuoteButton.disabled = true;
        emailQuoteButton.textContent = "Sending...";

        try{

            const result =
                await emailQuoteToBackend();

            console.log(
                "Email quote response:",
                result
            );

            alert(
                "Your quote has been emailed."
            );

        }catch(error){

            console.error(
                "Email quote error:",
                error
            );

            alert(
                error.message ||
                "Something went wrong. Please try again."
            );

        }finally{

            emailQuoteButton.disabled = false;
            emailQuoteButton.textContent = "Email My Quote";

        }

    });

}

});

// ======================================================
// CALCULATOR FLOW ENGINE
// ======================================================

let currentService = 0;

let dynamicMode = "tasks";


// ======================================================
// START TASK FLOW
// ======================================================

function startTaskFlow(){

    buildTaskScreens();

    currentService = 0;

    dynamicMode = "tasks";

    const firstService =
        state.selectedServices[currentService];

    if(!firstService){

        return;

    }

    loadTasks(firstService);

    showScreen(4);

    updateProgress();

}


// ======================================================
// NEXT SERVICE
// ======================================================

function nextService(){

    currentService++;

    // More services remain
    if(
        currentService <
        state.selectedServices.length
    ){

        dynamicMode = "tasks";

        loadTasks(
            state.selectedServices[currentService]
        );

        updateProgress();

        return;
    }

    // All services completed
    buildQuestionQueue();

}


// ======================================================
// PREVIOUS SERVICE
// ======================================================

function previousService(){

    if(currentService > 0){

        currentService--;

        dynamicMode = "tasks";

        loadTasks(
            state.selectedServices[currentService]
        );

        updateProgress();

        return;

    }

    showScreen(3);

    updateProgress();

}


// ======================================================
// BUILD QUESTION QUEUE
// ======================================================

function buildQuestionQueue(){

    state.questionQueue = [];

    state.currentQuestion = 0;


    // ------------------------------------------
    // SELECTED TASK QUESTIONS
    // ------------------------------------------

    state.selectedServices.forEach(service=>{

        const serviceConfig =
            CONFIG.services[service];

        const selectedTasks =
            state.selectedTasks[service] || [];


        Object.values(serviceConfig.tasks)
        .forEach(task=>{

            if(
                !selectedTasks.includes(task.name)
            ){
                return;
            }


            if(
                !Array.isArray(task.questions)
            ){
                return;
            }


            task.questions.forEach(question=>{

                state.questionQueue.push({

                    ...question,
                    service:service,
                    task:task.name

                });

            });

        });

    });


    // ------------------------------------------
    // GLOBAL / COMPANY QUESTIONS
    // ------------------------------------------

    Object.values(CONFIG.globalQuestions)
    .forEach(question=>{

        state.questionQueue.push({

            ...question,
            service:"General"

        });

    });


    dynamicMode = "questions";

    showScreen(4);

    loadQuestion();

    updateProgress();

}

// ======================================================
// GET CURRENT QUESTION
// ======================================================

function getCurrentQuestion(){

    return state.questionQueue[
        state.currentQuestion
    ] || null;

}

// ======================================================
// OPTION ICONS
// ======================================================

function getOptionIcon(option){

    const icons = {

        "Instagram": "instagram",
        "Facebook": "facebook",
        "TikTok": "tiktok",
        "LinkedIn": "linkedin",
        "Google": "googleads",
        "Meta": "meta",
        "Microsoft": "microsoft",
        "Amazon": "amazon",
        "Shopify": "shopify",
        "Wix": "wix",
        "Squarespace": "squarespace",
        "WooCommerce": "woocommerce",
        "Etsy": "etsy",
        "Google Merchant Centre": "googlemerchantcenter",
        "TikTok Shop": "tiktokshop",
        "Meta Shop": "meta"

    };

    const slug = icons[option];

    if(!slug){
        return "";
    }

    return `
        <img
            src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/${slug}.svg"
            alt=""
            aria-hidden="true"
        >
    `;

}
// ======================================================
// LOAD QUESTION
// ======================================================

function loadQuestion(){

    let question =
        getCurrentQuestion();


    // ------------------------------------------
    // Skip conditional questions
    // ------------------------------------------

    while(question){

        if(!question.showIf){

            break;

        }


        const answer =
            state.answers[
                question.showIf.question
            ];


        const shouldShow =
            Array.isArray(answer)

            ? answer.includes(
                question.showIf.value
            )

            : answer === question.showIf.value;


        if(shouldShow){

            break;

        }


        state.currentQuestion++;

        question =
            getCurrentQuestion();

    }


    // ------------------------------------------
    // No more questions
    // ------------------------------------------

  if(!question){

    generateSummary();
    showScreen(6);
    updateProgress();
    return;

}


    // ------------------------------------------
    // Breadcrumb
    // ------------------------------------------

    const breadcrumb =
        document.querySelector(
            ".question-breadcrumb"
        );

    const serviceElement =
        document.getElementById(
            "questionService"
        );

    const taskElement =
        document.getElementById(
            "questionTask"
        );


    if(
        question.service === "General"
    ){

        if(breadcrumb){

            breadcrumb.style.display = "none";

        }

    }else{

        if(breadcrumb){

            breadcrumb.style.display = "flex";

        }

        if(serviceElement){

            serviceElement.textContent =
                question.service;

        }

        if(taskElement){

            taskElement.textContent =
                question.task || "";

        }

    }


    // ------------------------------------------
    // Question content
    // ------------------------------------------

    document.getElementById(
        "dynamicQuestion"
    ).textContent =
        question.question;


    document.getElementById(
        "dynamicDescription"
    ).textContent =
        question.description || "";


    // ------------------------------------------
    // Build options
    // ------------------------------------------

    const container =
        document.getElementById(
            "dynamicOptions"
        );

    container.innerHTML = "";


    let options =
        question.options || {};


    // Convert CONFIG option objects
    // into display labels

    if(
        !Array.isArray(options)
    ){

        options =
            Object.values(options)
            .map(option=>{

                return option.label;

            });

    }


    options.forEach(option=>{

        const card =
            document.createElement("div");

        card.className =
            "option";


        // Restore previous selection

        const saved =
            state.answers[
                question.id
            ];


        if(
            Array.isArray(saved)
            && saved.includes(option)
        ){

            card.classList.add("selected");

        }

        else if(
            !Array.isArray(saved)
            && saved === option
        ){

            card.classList.add("selected");

        }


const icon =
    getOptionIcon(option);

card.innerHTML = `

    <div class="option-content">

        ${
            icon
                ? `<span class="option-icon">${icon}</span>`
                : ""
        }

        <span class="option-label">
            ${option}
        </span>

    </div>

`;


        card.onclick = function(){

            // ----------------------------------
            // MULTI SELECT
            // ----------------------------------

            if(
                question.type === "multi"
            ){

                if(
                    !Array.isArray(
                        state.answers[
                            question.id
                        ]
                    )
                ){

                    state.answers[
                        question.id
                    ] = [];

                }


                const selected =
                    state.answers[
                        question.id
                    ];


                if(
                    selected.includes(option)
                ){

                    state.answers[
                        question.id
                    ] =
                        selected.filter(
                            item =>
                                item !== option
                        );

                    card.classList.remove(
                        "selected"
                    );

                }

                else{

                    selected.push(option);

                    card.classList.add(
                        "selected"
                    );

                }


                document.getElementById(
                    "dynamicContinue"
                ).disabled =
                    selected.length === 0;


                return;

            }


            // ----------------------------------
            // SINGLE SELECT
            // ----------------------------------

            document
                .querySelectorAll(
                    "#dynamicOptions .option"
                )
                .forEach(item=>{

                    item.classList.remove(
                        "selected"
                    );

                });


            card.classList.add(
                "selected"
            );


            state.answers[
                question.id
            ] = option;


            document.getElementById(
                "dynamicContinue"
            ).disabled = false;

        };


        container.appendChild(card);

    });


    // ------------------------------------------
    // Continue button state
    // ------------------------------------------

    const saved =
        state.answers[
            question.id
        ];


    document.getElementById(
        "dynamicContinue"
    ).disabled =

        question.type === "multi"

        ? !Array.isArray(saved)
          || saved.length === 0

        : !saved;


    updateProgress();

}


// ======================================================
// CONTINUE BUTTON
// ======================================================

function nextQuestion(){

    // ------------------------------------------
    // TASK SELECTION MODE
    // ------------------------------------------

    if(
        dynamicMode === "tasks"
    ){

        const selectedTasks =
            state.selectedTasks[
                state.selectedServices[
                    currentService
                ]
            ] || [];


        if(
            selectedTasks.length === 0
        ){

            return;

        }


        nextService();

        return;

    }


    // ------------------------------------------
    // QUESTION MODE
    // ------------------------------------------

    const question =
        getCurrentQuestion();


  if(!question){
    generateSummary();
    showScreen(6);
    return;
}


    const answer =
        state.answers[
            question.id
        ];


    // Require answer

    if(
        question.type === "multi"
    ){

        if(
            !Array.isArray(answer)
            || answer.length === 0
        ){

            return;

        }

    }

    else{

        if(!answer){

            return;

        }

    }


    state.currentQuestion++;


    loadQuestion();

    updateProgress();

}


// ======================================================
// PREVIOUS QUESTION
// ======================================================

function previousQuestion(){

    if(
        dynamicMode === "tasks"
    ){

        previousService();

        return;

    }


    if(
        state.currentQuestion > 0
    ){

        state.currentQuestion--;

        loadQuestion();

        return;

    }


    dynamicMode = "tasks";

    currentService =
        state.selectedServices.length - 1;

    loadTasks(
        state.selectedServices[
            currentService
        ]
    );

    updateProgress();

}


// ======================================================
// SCREEN NAVIGATION
// ======================================================

function showScreen(screenNumber){

    document
        .querySelectorAll(".screen")
        .forEach(screen=>{

            screen.classList.remove(
                "active"
            );

        });


    const screen =
        document.getElementById(
            "screen" + screenNumber
        );


    if(screen){

        screen.classList.add(
            "active"
        );

    }


    currentScreen =
        screenNumber;


    updateProgress();

}


// ======================================================
// PROGRESS
// ======================================================

function updateProgress(){

    const progressBar =
        document.getElementById(
            "progressBar"
        );

    const progressLabel =
        document.getElementById(
            "progressLabel"
        );


    let progress = 0;


    // ------------------------------------------
    // START
    // ------------------------------------------

    if(currentScreen === 1){

        progress = 0;

    }


    // ------------------------------------------
    // SUPPORT
    // ------------------------------------------

    else if(currentScreen === 2){

        progress = 20;

    }


    // ------------------------------------------
    // SERVICES
    // ------------------------------------------

    else if(currentScreen === 3){

        progress = 40;

    }


    // ------------------------------------------
    // SERVICE TASKS
    // ------------------------------------------

    else if(
        currentScreen === 4 &&
        dynamicMode === "tasks"
    ){

        const serviceCount =
            state.selectedServices.length;

        if(serviceCount > 0){

            progress =
                40 +
                (
                    currentService /
                    serviceCount
                ) * 20;

        }
        else{

            progress = 40;

        }

    }


    // ------------------------------------------
    // QUESTIONS
    // ------------------------------------------

    else if(
        currentScreen === 4 &&
        dynamicMode === "questions"
    ){

        const totalQuestions =
            state.questionQueue.length;

        if(totalQuestions > 0){

            progress =
                60 +
                (
                    state.currentQuestion /
                    totalQuestions
                ) * 40;

        }
        else{

            progress = 100;

        }

    }


    // ------------------------------------------
    // SUMMARY
    // ------------------------------------------

    else if(currentScreen === 6){

        progress = 100;

    }


    progress =
        Math.max(
            0,
            Math.min(
                100,
                Math.round(progress)
            )
        );


    // ------------------------------------------
    // UPDATE PROGRESS BAR
    // ------------------------------------------

    if(progressBar){

        progressBar.style.width =
            `${progress}%`;

    }


// ------------------------------------------
// UPDATE LABEL
// ------------------------------------------

if(progressLabel){

    if(currentScreen === 1){

        progressLabel.textContent =
            "Step 1";

    }

    else if(currentScreen === 2){

        progressLabel.textContent =
            "Step 2";

    }

    else if(currentScreen === 3){

        progressLabel.textContent =
            "Step 3";

    }

    else if(
        currentScreen === 4 &&
        dynamicMode === "tasks"
    ){

        progressLabel.textContent =
            "Selecting services";

    }

    else if(
        currentScreen === 4 &&
        dynamicMode === "questions"
    ){

        progressLabel.textContent =
            "Tailoring your quote";

    }

    else if(currentScreen === 6){

        progressLabel.textContent =
            "Complete";

    }

}

// ------------------------------------------
// UPDATE PERCENTAGE
// ------------------------------------------

const progressPercent =
    document.getElementById(
        "progressPercent"
    );

if(progressPercent){

    progressPercent.textContent =
        `${progress}%`;

}

}

// ======================================================
// RESTART
// ======================================================
function restartCalculator(){

    state.supportType = "oneOff";
    state.selectedServices = [];
    state.selectedTasks = {};
    state.answers = {};
    state.questionQueue = [];
    state.currentQuestion = 0;
    state.quote = null;

    currentService = 0;
    dynamicMode = "tasks";


    document
        .querySelectorAll(
            ".option"
        )
        .forEach(option=>{

            option.classList.remove(
                "selected"
            );

        });


    const supportContinue =
        document.getElementById(
            "supportContinue"
        );

    if(supportContinue){

        supportContinue.disabled =
            true;

    }


    const servicesContinue =
        document.getElementById(
            "servicesContinue"
        );

    if(servicesContinue){

        servicesContinue.disabled =
            true;

    }


    const dynamicContinue =
        document.getElementById(
            "dynamicContinue"
        );

    if(dynamicContinue){

        dynamicContinue.disabled =
            true;

    }


    showScreen(1);

}


// ======================================================
// DEBUG
// ======================================================

async function saveQuoteToBackend(){

    if(!state.quote){
        throw new Error("No quote available");
    }

    const response =
        await fetch(
            CONFIG.api.url,
            {
                method:"POST",
                headers:{
                    "Content-Type":"application/json"
                },
                body:JSON.stringify({
                    action:"saveQuote",
                    supportType:state.supportType,
                    quote:state.quote,
                    selectedServices:state.selectedServices,
                    selectedTasks:state.selectedTasks,
                    answers:state.answers
                })
            }
        );

    if(!response.ok){

        const errorData =
            await response.json().catch(() => null);

        throw new Error(
            errorData?.error ||
            `Backend request failed: ${response.status}`
        );

    }

    const result =
        await response.json();

    if(
        !result.success ||
        !result.quoteId
    ){

        throw new Error(
            result.error ||
            "Quote could not be saved"
        );

    }

    state.quote.quoteId =
        result.quoteId;

    return result;

}


async function emailQuoteToBackend(){

    if(!state.quote){
        throw new Error("No quote available");
    }

    const emailInput =
        document.getElementById("quoteEmail");

    if(!emailInput){
        throw new Error("Email field not found");
    }

    const email =
        emailInput.value.trim();

    if(!email){
        alert(
            "Please enter your email address."
        );
        return;
    }

    const response =
        await fetch(
            CONFIG.api.url,
            {
                method:"POST",
                headers:{
                    "Content-Type":"application/json"
                },
                body:JSON.stringify({
                    action:"emailQuote",
                    quoteId:state.quote.quoteId,
                    email:email
                })
            }
        );

    if(!response.ok){

        const errorData =
            await response.json().catch(() => null);

        throw new Error(
            errorData?.error ||
            `Email request failed: ${response.status}`
        );

    }

    const result =
        await response.json();

    if(!result.success){

        throw new Error(
            result.error ||
            "Quote email could not be sent"
        );

    }

    return result;

}

async function getQuoteFromBackend(quoteId){

    if(!quoteId){
        throw new Error("Quote ID is required");
    }

    const response =
        await fetch(
            CONFIG.api.url,
            {
                method:"POST",
                headers:{
                    "Content-Type":"application/json"
                },
                body:JSON.stringify({
                    action:"getQuote",
                    quoteId:quoteId
                })
            }
        );

    if(!response.ok){

        const errorData =
            await response.json().catch(() => null);

        throw new Error(
            errorData?.error ||
            `Quote retrieval failed: ${response.status}`
        );

    }

    const result =
        await response.json();

    if(
        !result.success ||
        !result.quote
    ){

        throw new Error(
            result.error ||
            "Quote could not be retrieved"
        );

    }

    return result;

}

function copyQuoteLink(){

    if(!state.quote?.quoteId){
        return;
    }

    const quoteUrl =
        `${window.location.origin}${window.location.pathname}?quote=${encodeURIComponent(state.quote.quoteId)}`;

    navigator.clipboard.writeText(quoteUrl)
        .then(() => {

            alert(
                "Quote link copied!"
            );

        })
        .catch(error => {

            console.error(
                "Copy quote link error:",
                error
            );

            alert(
                "Unable to copy the quote link."
            );

        });

}

async function loadSavedQuote(quoteId){
    const result =
        await getQuoteFromBackend(quoteId);

    state.supportType =
        result.supportType;

    state.selectedServices =
        result.selectedServices || [];

    state.selectedTasks =
        result.selectedTasks || {};

    state.answers =
        result.answers || {};

    state.quote =
        result.quote || null;

    if(state.quote){

        state.quote.quoteId =
            result.quoteId;

    }

    return result;

}

async function sendQuoteToBackend(){

    if(!state.quote){
        throw new Error("No quote available");
    }

    const response =
        await fetch(
            CONFIG.api.url,
            {
                method:"POST",
                headers:{
                    "Content-Type":"application/json"
                },
                body:JSON.stringify({
                    action:"createPayment",
quoteId:state.quote?.quoteId || null,
supportType:state.supportType,
quote:state.quote,
selectedServices:state.selectedServices,
selectedTasks:state.selectedTasks,
answers:state.answers
                })
            }
        );

    if(!response.ok){

        const errorData =
            await response.json().catch(() => null);

        throw new Error(
            errorData?.error ||
            `Backend request failed: ${response.status}`
        );

    }

    const result =
        await response.json();

    if(!result.success || !result.quote){

        throw new Error(
            result.error ||
            "Invalid backend response"
        );

    }

    state.quote = {
        ...state.quote,
        ...result.quote
    };

    return result;

}

function debugCalculator(){

    console.log(
        "STATE:",
        state
    );

    console.log(
        "CONFIG:",
        CONFIG
    );

    console.log(
        "MODE:",
        dynamicMode
    );

    console.log(
        "CURRENT SERVICE:",
        currentService
    );

    console.log(
        "CURRENT QUESTION:",
        state.currentQuestion
    );

}